import React, { useContext, useEffect, useRef, useState } from "react";
import { environmentVariables } from "../../config/env.config";
import { userContext } from "../../context/userContext";
import PageName from "../Utils/PageName";
import DataTable from "react-data-table-component";
import SortIcon from "@material-ui/icons/ArrowDownward";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { useTranslation } from "react-i18next";
import axios from "axios";
import CircularLoader from "../Components/CircularLoader/CircularLoader";
import { formatDateTime } from "../Components/DateTimeFormat/DateTimeFormat";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getCurrencyDataByCurrency, subtractDays } from "../../utils/utility";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import moment from "moment";
import { FaCalendarAlt } from 'react-icons/fa';
import "./CustomPaymentHistoryStyle.css";
import DownloadExcel from "../../../src/Images/downloadExcel.svg";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
const WalletHistory = () => {
  const baseUrl = environmentVariables?.apiUrl;
  const { t } = useTranslation();

  const { userData } = useContext(userContext);
  const [responseData, setResponseData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  let countryList = [
    { name: "India", c_code: "IN", phone_code: "+91" },
    { name: "United Arab Emirates", c_code: "AE", phone_code: "+971" }
  ]
  const [countryData, setCountryData] = useState(countryList);
  const [activeCountry, setActiveCountry] = useState("IN");
  const [selectedDateFrom, setSelectedDateFrom] = useState("");
  const [selectedDateTo, setSelectedDateTo] = useState("");
  const [nameOrderId, setNameOrderId] = useState("");
  const abortController = new AbortController();
  const fromDate = useRef(null);
  const toDate = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [open, setOpen] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const tableExtensions = {
    export: false,
    print: false,
  };

  function useWindowWidth() {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    return width;
  }

  const windowWidth = useWindowWidth();

  const handleViewMessage = (d) => {
    setOpen(true);
    setSelectedMessage(d);
    setIsModalOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
    setIsModalOpen(false);
  };

  const getStatusStyle = (status) => {
    const styles = {
      cr: { color: "#26a56a", background: "#26a56a33" },
    };

    const { color = "#e71c1f", background = "#e71c1f33" } = styles[status] || {};

    return {
      fontWeight: "500",
      color,
      background,
      borderRadius: "4px",
      padding: "2px 10px",
      textTransform: "capitalize",
      minWidth: "90px",
      maxWidth: "fit-content",
      display: "block",
      textAlign: "center",
    };
  };

  const columns = [
    {
      name: t("Transaction_id"),
      selector: (row) =>
        row?.transaction_id
          ? row?.transaction_id
          : row?.order_number || "--",
      sortable: true,
      cell: (row) => (
        <div className="custom-cell order-id-cell custom-cell-bold" data-column-name={t("Order_id")}>
          {row?.transaction_id || "--"}
        </div>
      ),
      minWidth: windowWidth > 768 ? "180px" : "100%",
    },
    {
      name: t("Opening_balance"),
      selector: (row) => {
        let currency = row?.currency === "د." || row?.currency === "AED" ? "AED" : (row?.currency)
        if (currency === "AED") {
          return `${row?.opening_balance} ${currency}` || "--"
        } else {
          return `${getCurrencyDataByCurrency(currency)}${row?.opening_balance}` || "--"
        }
      },
      cell: (row) => (
        <div className="custom-cell custom-cell-bold" data-column-name="Opening Balance">
          {
            row?.opening_balance == null
              ? "--"
              : row?.currency === "د." || row?.currency === "AED"
                ? `${row.opening_balance} AED`
                : `${getCurrencyDataByCurrency(row.currency)}${row.opening_balance}`
          }        </div>
      ),
      sortable: true,
      minWidth: "180px",
    },
    {
      name: t("Amount"),
      selector: (row) => {
        let currency = row?.currency === "د." || row?.currency === "AED" ? "AED" : (row?.currency)
        if (currency === "AED") {
          return `${row?.amount} ${currency}` || "--"
        } else {
          return `${getCurrencyDataByCurrency(currency)}${row?.amount}` || "--"
        }
      },
      cell: (row) => (
        <div className="custom-cell custom-cell-bold" data-column-name={t("Amount")}>
          {
            row?.amount == null
              ? "--"
              : <>
                <span style={getStatusStyle(row?.type)}>
                  {row?.type === "cr" ? "+" : "-"} {row?.currency === "د." || row?.currency === "AED"
                    ? `${row.amount} AED`
                    : `${getCurrencyDataByCurrency(row.currency)}${row.amount}`}
                </span>

              </>


          }
        </div>
      ),
      sortable: true,
      minWidth: "180px",
    },
    {
      name: t("Fees"),
      selector: (row) =>
        row?.fee
          ? row?.currency === "د." || row?.currency === "AED"
                    ? `${row.fee} AED`
                    : `${getCurrencyDataByCurrency(row.currency)}${row.fee}` : "--",
      sortable: true,
      cell: (row) => (
        <div className="custom-cell order-id-cell custom-cell-bold" data-column-name={t("Fees")}>
          {row?.currency === "د." || row?.currency === "AED"
                    ? `${row.fee} AED`
                    : `${getCurrencyDataByCurrency(row.currency)}${row.fee}`  || "--"}
        </div>
      ),
      minWidth: windowWidth > 768 ? "180px" : "100%",
    },
    {
      name: t("Closing_balance"),
      selector: (row) => {

        let currency = row?.currency === "د." || row?.currency === "AED" ? "AED" : (row?.currency)
        if (currency === "AED") {
          return `${row?.closing_balance} ${currency}` || "--"
        } else {
          return `${getCurrencyDataByCurrency(currency)}${row?.closing_balance}` || "--"
        }
      },
      cell: (row) => (
        <div className="custom-cell custom-cell-bold" data-column-name="Closing Balance">
          {
            row?.closing_balance == null
              ? "--"
              : <>

                {row?.currency === "د." || row?.currency === "AED"
                  ? `${row.closing_balance} AED`
                  : `${getCurrencyDataByCurrency(row.currency)}${row.closing_balance}`
                }
              </>
          }
        </div>
      ),
      sortable: true,
      minWidth: "180px",
    },
    {
      name: t("Wallet"),
      selector: (row) =>
        row?.wallet_type || "--",
      sortable: true,
      cell: (row) => (
        <div className="custom-cell order-id-cell custom-cell-bold" data-column-name={t("Wallet")}>
          {row?.wallet_type || "--"}
        </div>
      ),
      minWidth: windowWidth > 768 ? "180px" : "100%",
    },

    {
      name: "Action",
      sortable: false,
      cell: (d) => (
        <div onClick={() => handleViewMessage(d)}
          style={{ cursor: "pointer", marginRight: "10px", width: "100%" }}>
          {windowWidth > 768 ? <i
            className="first fas fa-eye"

          ></i> : <p style={{ textDecoration: "underline", width: "100%", textAlign: "right", fontSize: "14px" }}>View Details</p>
          }</div>

      ),
      minWidth: "180px"
    }
  ];

  const customStyles = {
    headRow: {
      style: {
        width: "100%",
        backgroundColor: "#F8FBFF",
        minHeight: "52px",
        borderRadius: "2px 2px 0px 0px",
        padding: "8px 25px",
        border: "none",
        textAlign: "left",
        boxShadow:"0 2px 2px -1px rgba(0, 0, 0, 0.1)"
      },
    },
    headCells: {
      style: {
        color: "#000000DE",
        fontFamily: "DM Sans",
        fontSize: "16px",
        fontWeight: "600",
        minHeight: "52px",
        padding: "8px 10px",
        textAlign: "left",
      },
    },
    rows: {
      style: {
        padding: "6px 0px 6px 25px", // Ensure similar padding here
        fontSize: "13px", // Match font size with header
        textTransform: "capitalize",
        minHeight: "48px !important",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
      },
    },
    cells: {
      style: {
        // minWidth: "50px !important",
        padding: "0px 5px", // Same padding as header cells
        fontSize: "13px", // Match font size with header
        textAlign: "left", // Ensure same text alignment as header
      },
    },
  };

  const tableData = {
    columns,
    data: responseData,
  };
  const paginationOptions = {
    rowsPerPageText: t("Rows_per_page"),
    rangeSeparatorText: t("Of"),
    noRowsPerPage: false,
    selectAllRowsItem: false,
    // selectAllRowsItemText: t("All"),
  };

  async function fetchData(page, size = perPage) {
    try {
      const response = await axios.get(
        `${baseUrl}api/v1/custompayment/get_wallethistory?countryCode=${activeCountry}&from_date=${selectedDateFrom}&to_date=${selectedDateTo}&page=${page}&limit=${size}&nameOrderId=${nameOrderId}`,
        {
          headers: {
            _token: userData?.token,
          },
          signal: abortController.signal,
        }
      );
      if (response.status === 200) {
        const { mainData, total, currentPage } = response?.data;
        setResponseData(mainData);
        setTotalRows(total || 0);
        setCurrentPage(currentPage)
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      setResponseData([]);
    }
  }
  useEffect(() => {
    fetchData(1);
    return () => {
      abortController.abort();
    };
  }, [
    activeCountry,
    selectedDateFrom,
    selectedDateTo,
    nameOrderId,
    // currentPage,
    // perPage
  ]);

  const handleReset = () => {
    setSelectedDateFrom("");
    setSelectedDateTo("");
    setNameOrderId("");
    setActiveCountry("IN");
  };

  const handlePageChange = (page) => {
    fetchData(page);
  };

  const handleChangeCountryData = (e) => {
    const countryName = e.target.value;
    setActiveCountry(countryName);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    fetchData(page, newPerPage);
  };

  const exportToExcel = async () => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    try {
      const response = await axios.get(
        `${baseUrl}api/v1/custompayment/get_all_custom_payments?countryCode=${activeCountry}&fromDate=${selectedDateFrom}&toDate=${selectedDateTo}&nameOrderId=${nameOrderId}&page=1&limit=1000`,
        {
          headers: {
            _token: userData?.token,
          },
          signal: abortController.signal,
        }
      );

      const usersAllData = response?.data?.data || [];
      const formattedData = usersAllData.map((item) => ({
        CustomerName: item?.customer_name || "--",
        CustomerEmail: item?.customer_email || "--",
        Contact: `${item?.phone_code || "+91"} ${item?.phone || ""}`,
        BusinessName: item?.businesses?.title || "--",
        BusinessOwnerName: item?.businesses?.sub_title || "--",
        Amount: item?.currency === "د." ? `${item?.amount} AED` : `${item?.currency}${item?.amount}`,
        SettlementAmount: item?.currency === "د." ? `${item?.settlement_amount} AED` : `${item?.currency}${item?.settlement_amount}`,
        SettlementFee: item?.currency === "د." ? `${item?.settlement_fee} AED` : `${item?.currency}${item?.settlement_fee}`,
        SettlementTime: `${item?.settlement_time}h` || "--",
        CreatedAt: item?.created_at
          ? new Date(item.created_at).toLocaleDateString("en-GB")
          : "--",
        OrderId: item?.custom_payments?.order_id || "--",
        PaymentStatus: item?.payment_status || "--",
      }));

      const ws = XLSX.utils.json_to_sheet(formattedData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });

      const fileName = `Payin_History_${new Date()
        .toISOString()
        .split("T")[0]}${fileExtension}`;

      saveAs(data, fileName);
    } catch (error) {
      console.error("Export to Excel failed:", error);
    }
  };

  return (
    <>
      <div id="custom_table" className="walletHistory">
        <PageName PageName="Wallet  History" />

        <div className="superadminsearch_style upperFilter">

          <input
            type="text"
            // class="form-control clear_string"
            class="superadminsearchinput"
            placeholder={t("Search_txn_id")}
            value={nameOrderId}
            onChange={(e) => setNameOrderId(e.target.value)}
            style={{ width: "300px" }}
          />

          <div className="upperFilter" style={{ margin: "0" }}>
            {userData?.user_type == "super_admin" && (
              <div className="selectCountry" style={{ width: "300px" }}>
                <select
                  style={{ cursor: "pointer" }}
                  value={activeCountry}
                  onChange={(e) => handleChangeCountryData(e)}
                  class="form-select"
                >
                  {""}
                  <option value={""}>{t("Select_country")}</option>
                  {countryData &&
                    countryData.map((val, index) => (
                      <option key={index} value={val?.c_code}>
                        {val?.name}
                      </option>
                    ))}
                </select>
              </div>
            )}
            <div className="filterWrapper" style={{ width: "auto" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <DatePicker
                  placeholderText={t("From_date")}
                  selected={
                    selectedDateFrom ? new Date(selectedDateFrom) : null
                  }
                  onChange={(date) => {
                    if (date) {
                      const timestamp = date.getTime(); // Get the timestamp in milliseconds
                      setSelectedDateFrom(timestamp);
                    }
                  }}
                  className="form-control"
                  ref={fromDate}
                  minDate={subtractDays(30)}
                  maxDate={new Date()}
                  dateFormat="dd/MM/yyyy"
                  popperPlacement="bottom-end"
                />
                <FaCalendarAlt className="calenderIcon" />
                <DatePicker
                  placeholderText={t("To_date")}
                  selected={selectedDateTo ? new Date(selectedDateTo) : null}
                  onChange={(date) => {
                    if (date) {
                      const timestamp = date.getTime();
                      setSelectedDateTo(timestamp);
                    }
                  }}
                  className="form-control"
                  ref={toDate}
                  minDate={selectedDateFrom ? selectedDateFrom : subtractDays(30)}
                  maxDate={new Date()}
                  dateFormat="dd/MM/yyyy"
                  popperPlacement="bottom-end"
                  style={{ width: "95%" }}
                />
                <FaCalendarAlt className="calenderIcon" />
              </div>
              <div>
                <button
                  class="contact_filter_buttonstyle"
                  onClick={() => handleReset()}
                >
                  {/* Reset{" "} */}
                  <i className="fa-solid fa-filter-circle-xmark" aria-hidden="true"></i>&nbsp;
                  <span className="clearFilter">{t("Clear_filters")}</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="main inf_dash walletMobileTable">
            <h3 className="payin-payout-request-heading" style={{marginBottom:"20px"}}>{t("Transaction_history")}</h3>
        <div className="main">
          {isLoading ? (
            <CircularLoader size={40} />
          ) : (
            <>
              <DataTableExtensions
                {...tableExtensions}
                {...tableData}
                customStyles={customStyles}
                filterPlaceholder="Search User By name"
              >
                <DataTable
                  columns={columns}
                  data={responseData}
                  noHeader
                  defaultSortField="id"
                  sortIcon={<SortIcon />}
                  defaultSortAsc={true}
                  pagination
                  paginationServer
                  paginationRowsPerPageOptions={[10, 15, 20, 25, 30]}
                  paginationTotalRows={totalRows}
                  onChangePage={handlePageChange}
                  onChangeRowsPerPage={handlePerRowsChange}
                  highlightOnHover
                  dense
                  // paginationPerPage={perPage}
                  paginationComponentOptions={{
                    ...paginationOptions,
                  }}
                  progressPending={isLoading}
                  customStyles={customStyles}
                  noDataComponent={
                    <div style={{ padding: "24px" }}>{t("No_records_found")}</div>
                  }
                />
              </DataTableExtensions>
            </>
          )}
        </div>
        </div>
      </div>

      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        open={open}
        onClose={() => hideModal()}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Sheet
          variant="outlined"
          sx={{
            maxWidth: 500,
            minWidth: 390,
            borderRadius: "md",
            p: 3,
            boxShadow: "lg",
          }}
          className="paymentInfproductdetails "
        >
          <ModalClose variant="plain" sx={{ m: 1 }} />
          <Typography
            component="h2"
            id="modal-title"
            level="h4"
            textColor="inherit"
            fontWeight="lg"
            mb={2}
            textAlign="center"
          >
            {t("Order_details_small")}
          </Typography>
          <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}><span>{t("Transaction_id")}:</span><span style={{ fontWeight: "700", wordBreak: "break-all" }}>{selectedMessage?.transaction_id == null ? "--" : selectedMessage?.transaction_id}</span></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}><span>{t("Owner_name")}:</span><span style={{ fontWeight: "700", wordBreak: "break-all" }}>{selectedMessage?.user_id == null ? "--" : selectedMessage?.userDetails?.name}</span></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}><span>{t("Owner_email")}:</span><span style={{ fontWeight: "700", wordBreak: "break-all" }}>{selectedMessage?.user_id == null ? "--" : selectedMessage?.userDetails?.email}</span></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}><span>{t("Date")}:</span><span style={{ fontWeight: "700" }}>{moment(selectedMessage?.created_at).format("DD-MMM-YYYY HH:mm:ss")}</span></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}><span>{t("Amount")}:</span><span style={{ fontWeight: "700" }}>{selectedMessage?.amount == null ? "--" : selectedMessage?.currency === "د." || selectedMessage?.currency === "AED" ? `${selectedMessage.amount} AED` : `${getCurrencyDataByCurrency(selectedMessage.currency)}${selectedMessage.amount}`}   </span></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}><span>{t("settlement_amount")}:</span><span style={{ fontWeight: "700" }}>{selectedMessage?.settlement_amount == null ? "--" : selectedMessage?.currency === "د." || selectedMessage?.currency === "AED" ? `${selectedMessage.settlement_amount} AED` : `${getCurrencyDataByCurrency(selectedMessage.currency)}${selectedMessage.settlement_amount}`}   </span></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}><span>{t("settlement_fee")}:</span><span style={{ fontWeight: "700" }}>{selectedMessage?.fee == null ? "--" : selectedMessage?.currency === "د." || selectedMessage?.currency === "AED" ? `${selectedMessage.fee} AED` : `${getCurrencyDataByCurrency(selectedMessage.currency)}${selectedMessage.fee}`} </span></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}><span>{t("Wallet")}:</span><span style={{ fontWeight: "700" }}>{selectedMessage?.wallet_type}</span></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}><span>{t("Transaction_status")}:</span><span style={getStatusStyle(selectedMessage?.type)}>{selectedMessage?.type == "cr" ? "Credited" : "Debited"}</span></div>
          </div>
        </Sheet>
      </Modal>
    </>
  );
};

export default WalletHistory;
